import React, { useMemo } from 'react';

import { SingleQuestionController } from '@sm/question-widgets/respondent-survey';
import { ExternalQuestion } from '@sm/question-definitions';
import { ScrollAnchor } from '~app/components/Survey/OneQuestionAtATime';
import { ScrollAnchorRenderProps } from '~app/components/Survey/OneQuestionAtATime/ScrollAnchor';
import groupQuestionsWithLayoutConfig from './utils';
import { QuestionRowLayout } from '../QuestionRowLayout';
import { QuestionAnswers } from '../../types';

export type Props = {
  questions: ExternalQuestion[];
  answers: QuestionAnswers;
  /** Checks if the question coming in is OQAAT is default set to true */
  isOQAAT: boolean;
};

function QuestionList({ questions, answers, isOQAAT = true }: Props): React.ReactElement {
  const groups = useMemo(() => groupQuestionsWithLayoutConfig(questions), [questions]);

  return (
    <>
      {groups.map(group => (
        <QuestionRowLayout maxQuestionsPerRow={isOQAAT ? 1 : 4} key={`group_${group.map(g => g.id).concat('-')}`}>
          {group.map(question => (
            <ScrollAnchor key={question.id}>
              {
                (({ isActive, nextQuestion }: ScrollAnchorRenderProps) => (
                  <SingleQuestionController
                    {...{ question }}
                    displayOptions={{ answer: answers[question.id], onSubmit: nextQuestion, active: isActive }}
                  />
                )) as any
              }
            </ScrollAnchor>
          ))}
        </QuestionRowLayout>
      ))}
    </>
  );
}

export default QuestionList;
